import Repository from "./Repository";

const GET_FRIENDS_UPDATES = "get";
const CREATE_FRIENDS_UPDATES = "create";
const UPDATE_FRIENDS_UPDATES = "update";
const DELETE_FRIENDS_UPDATES = "delete";

export default {
  createFriends(payload) {
    return Repository.post(transformRoute(CREATE_FRIENDS_UPDATES), payload);
  },
  deleteFriends(payload) {
    return Repository.post(transformRoute(DELETE_FRIENDS_UPDATES), payload);
  },
  getFriends(payload) {
    return Repository.get(transformRoute(GET_FRIENDS_UPDATES), payload);
  },
  editFriends(payload) {
    return Repository.post(transformRoute(UPDATE_FRIENDS_UPDATES), payload);
  },
};

const transformRoute = (route) => {
  return `/cms/friends-updates/${route}`;
};
